import { CSSProperties } from "react";
import styles from "../../css/dist/index.module.css";

export const PieChart = ({ percent, size, thickness, className, style }: { percent: number, size: string, thickness: string, className?: string, style?: CSSProperties }) => {
  return (<div className={`${styles["radial-progress"]} ${styles["text-primary"]} ${className}`} style={{ "--value": percent, "--size": size, "--thickness": thickness, ...style } as React.CSSProperties } role="progressbar">
    <span className={`${styles["font-semibold"]}`}>{percent.toFixed(1)}%</span>
  </div>);
};
